/** Keep in sync with `.tc-input` max-height in TaskComments.css (`min(40vh, 220px)`). */
export const COMMENT_COMPOSER_MAX_HEIGHT_CAP_PX = 220;
export const COMMENT_COMPOSER_VH_FACTOR = 0.4;
export const COMMENT_COMPOSER_MIN_HEIGHT_PX = 34;

export function getCommentComposerMaxHeightPx(): number {
  if (typeof window === 'undefined') return COMMENT_COMPOSER_MAX_HEIGHT_CAP_PX;
  return Math.min(COMMENT_COMPOSER_VH_FACTOR * window.innerHeight, COMMENT_COMPOSER_MAX_HEIGHT_CAP_PX);
}

/** Auto-grow task/ops comment textarea height up to the composer max (matches CSS cap). */
export function syncCommentComposerTextareaHeight(el: HTMLTextAreaElement | null): void {
  if (!el) return;
  const max = getCommentComposerMaxHeightPx();
  el.style.height = 'auto';
  const next = Math.min(el.scrollHeight, max);
  el.style.height = `${Math.max(next, COMMENT_COMPOSER_MIN_HEIGHT_PX)}px`;
}
